var map = {
	"./clothingRack.png": 55012,
	"./countertop.png": 61859,
	"./glassDisplay.png": 265,
	"./mannequin.png": 62865,
	"./otherDisplay.png": 53936,
	"./shelfDisplay.png": 57131,
	"./tableDisplay.png": 23428,
	"./windowDisplay.png": 61388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33520;